<template>
  <div>
    <!-- /.box-header -->
    <section class="content-header" style="height: 50px;">
      <h1 style="float: left; padding-right: 10px;">{{title}}</h1>
      <a title="Refresh Printer Data" class="btn-flat" style="margin-left: 10px; font-size: 20px; cursor: pointer;">
        <i @click="refreshPrinter()" :class="['fa fa-refresh', isRefresh?'fa-spin text-red':'']" style="color: #3c8dbc;"></i>
      </a>
      <va-button v-show="isDeleted" class="pull-left" :isBlock="false" theme="danger" name="Restore Printer" align="right" @click.native="restorePrinter"></va-button>
      <div class="box-tools pull-right">
        <span>Last Update: </span><b>{{lastUpdate}}</b>
      </div>
    </section>
    <div class="box-body">
      <div class="table-responsive">
        <div slot="content">
          <div class="col-lg-4 col-md-4 col-sm-12">
            <va-box title="Printer Information" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerInfo">
              <div slot="content">
                <div class="col-sm-12" v-for="item in printerInfo" style="padding-bottom: 10px;">
                  <span class="description-text">{{item.title}}</span>
                  <div class="description-block" style="background-color: #eee; padding: 5px; margin: 0px; height: 30px;">
                    <b class="text-right pull-right">{{item.value}}</b>
                  </div>
                </div>
              </div>
            </va-box>
            <va-box title="Customer Info" :isBorder="true" theme="box-warning" widgetType="">
              <div slot="content">
                <form class="form-horizontal">

                  <div class="form-group">
                    <label class="col-sm-4 control-label" style="text-align: left;">Customer Name</label>
                    <div class="col-sm-8">
                      <input type="text" readonly class="form-control" placeholder="CustomerName" :value="name" />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-4 control-label" style="text-align: left;">Email</label>
                    <div class="col-sm-8">
                      <input type="email" class="form-control" placeholder="Email" v-model="email" />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-4 control-label" style="text-align: left;">Phone</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" placeholder="Phone" v-model="phone" />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-4 control-label" style="text-align: left;">Customer Address</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" placeholder="Customer Address" v-model="address" />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-4 control-label" style="text-align: left;">Customer City</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" placeholder="Customer City" v-model="city" />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-4 control-label" style="text-align: left;">Contact Name</label>
                    <div class="col-sm-8">
                      <input type="email" class="form-control" placeholder="Contact Name" v-model="contact" />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-4 control-label" style="text-align: left;">Site</label>
                    <div class="col-sm-8">
                      <input type="text" readonly class="form-control" placeholder="Site" :value="site" />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-4 control-label" style="text-align: left;">Host Name</label>
                    <div class="col-sm-8">
                      <input type="text" readonly class="form-control" placeholder="HostName" :value="hostName" />
                    </div>
                  </div>
                </form>
              </div>
            </va-box>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <va-box title="Printer Counters" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerCounters">
              <div slot="content">
                <div class="col-sm-12" v-for="item in printerCounters" style="padding-bottom: 10px;">
                  <span class="description-text">{{item.title}}</span>
                  <div class="description-block" style="background-color: #eee; padding: 5px; margin: 0px; height: 30px;">
                    <b class="text-right pull-right">{{item.value}}</b>
                  </div>
                </div>
              </div>
            </va-box>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div v-if="showImage">
              <va-box title="Printer Image" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerInfo" :imagesList="images" @imageChanged="imageChanged">
                <div slot="content">
                  <img style="width: 100%; min-height: 100px; max-height: 500px;" :src="printer.imgUrl" ref="printerImage" />
                  <loading :active.sync="loadingImage" :is-full-page="isFullpage"></loading>
                </div>
                <div slot="footer">
                  <i class="fa fa-spinner fa-spin"></i>
                  <span>Saving image...</span>
                </div>
              </va-box>
            </div>
            <div>
              <va-box title="Printer Status" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerStatus">
                <div slot="content">
                  <div class="col-sm-12" v-for="item in printerStatus" style="padding-bottom: 10px;">
                    <span class="description-text">{{item.title}}</span>
                    <div class="description-block" style="background-color: #eee; padding: 2px; margin: 0px; height: 30px;">
                      <b class="text-right pull-right">{{item.value}}</b>
                    </div>
                  </div>
                </div>
              </va-box>
            </div>
            <va-box title="Printer Toners" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerToners">
              <div slot="content">
                <div class="col-sm-3" v-for="item in printerToners">
                  <div class="description-block" style="padding: 5px; height: 50px;">
                    <span class="col-sm-5 description-text text-left">{{item.title}}</span>
                    <br />
                    <span>
                      <div class="progress-group" style="width: 80px;">
                        <div class="progress sm" style="background-color: #ccc; height: 20px;">
                          <div v-if="item.value >= 0" :class="['progress-bar', 'progress' + item.title]" :style="{ width: item.value + '%' }">{{item.value}}%</div>
                          <div v-else>N/A</div>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </va-box>
            <va-box title="Printer Properties" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerProps">
              <div slot="content">
                <div class="col-sm-4" v-for="printerProp in printerProps" @click="printerProp.Value = !printerProp.Value">
                  <div class="tree-content tree--small" style="float: left!important;">
                    <i :class="['tree-checkbox', printerProp.Value?'checked':'']"></i>
                    <span tabindex="-1" class="tree-anchor">
                      <span class="tree-text" style="white-space: nowrap;">{{printerProp.Key}}</span>
                    </span>
                  </div>
                </div>
              </div>
            </va-box>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12" v-if="0>1">
            <va-box title="Printer History (last 10 records)" :isBorder="true" theme="box-warning" widgetType="question" :tooltip="tooltip.printerInfo">
              <div slot="content">
                <VueTable :columns="columns" :rows="printerHistory" :pageSize="100"></VueTable>
                <loading :active.sync="loadingPrinter" :is-full-page="isFullpage"></loading>
              </div>
            </va-box>
          </div>
        </div>
      </div>
      <div slot="footer">
        <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancelType"></va-button>
        <va-button :isBlock="false" theme="success" name="Save" align="right" @click.native="Save" style="margin-right: 10px;"></va-button>
      </div>
    </div>
    </div>
    <!--<loading :active.sync="loadingPrinter" :is-full-page="isFullpage"></loading>-->
</template>
<script>
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import VABox from '../components/VABox'
  import VAButton from '../components/VAButton'
  import VAAlert from '../components/VAAlert.vue'
  import VueTable from '../components/Table/DataTable.vue'
  import { db, dbListener } from '../firebase'
  export default {
    name: 'Printer',
    components: {
      'loading': Loading,
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-button': VAButton,
      'va-table': VueTable
    },
    data () {
      return {
        showImage: false,
        isDeleted: false,
        tmp: 'Set Printer Properties \n(Changes will be saved automaticaly)',
        tooltip: {
          printerInfo: 'Printer Informations and Details',
          printerCounters: 'Latest Printer Counters',
          printerStatus: 'Current printer status\nand messages',
          printerToners: 'Printer Toners \n(B/W printers will show Black Toner only)',
          // printerProps: 'Set Printer Properties \n(Changes will be saved automaticaly)'
          printerProps: 'Printer Properties'
        },
        printerHistory: [],
        CustomerKey: '',
        lastUpdate: '',
        dealer: '',
        name: '',
        city: '',
        email: '',
        address: '',
        site: '',
        hostName: '',
        phone: '',
        contact: '',
        currentPrinter: null,
        printerProps: [],
        printerInfo: [],
        printerCounters: [],
        printerStatus: [],
        printerToners: [],
        customerInfo: {
          customerKey: '',
          Name: '',
          Dealer: '',
          hostName: '',
          Phone: '',
          Email: '',
          Address: '',
          City: '',
          site: '',
          Contact: '',
          MacAddress: ''
        },
        images: [],
        isFullpage: false,
        loadingImage: false,
        loadingPrinter: false,
        title: '',
        printerType: {
          Key: '',
          ModelName: '',
          ImageUrl: '',
          IsMFC: false,
          IsPrinter: false,
          IsScanner: false,
          IsCopier: false,
          IsFax: false,
          IsColor: false,
          IsBW: false,
          IsA4: false,
          IsA3: false,
          IsDuplex: false
        },
        columns: [
          // { fieldName: 'Status', label: '', isSortable: false, isHidden: false, isStatus: true },
          { fieldName: 'Logged', sortFieldName: 'LoggedInt', label: 'Date', isSortable: true, isHidden: false, length: 20 },
          { fieldName: 'MacAddress', label: 'MAC Address', isSortable: true, isHidden: false },
          { fieldName: 'PrinterSerial', label: 'Serial', isSortable: true, isHidden: false, isLink: true, param: 'MacAddress' },
          { fieldName: 'ModelName', label: 'Model', isSortable: true, isHidden: false, length: 18 },
          { fieldName: 'PageCount', label: 'Pages', isSortable: true, isHidden: false },
          // { fieldName: 'IPAddress', label: 'IP Address', isSortable: true, isHidden: false },
          // { fieldName: 'HostName', label: 'Host', isSortable: true, isHidden: false },
          { fieldName: 'A4Black', label: 'A4Black', isSortable: true, isHidden: false, width: '80px' },
          { fieldName: 'A4Color', label: 'A4Color', isSortable: true, isHidden: false, width: '80px' },
          { fieldName: 'A3Black', label: 'A3Black', isSortable: true, isHidden: false, width: '80px' },
          { fieldName: 'A3Color', label: 'A3Color', isSortable: true, isHidden: false, width: '80px' },
          { fieldName: 'BlackTonerLeft', label: 'Black Toner', isSortable: true, isHidden: false, isProgress: true },
          // { fieldName: 'CyanTonerLeft', label: 'Cyan', isSortable: true, isHidden: false, isProgress: true },
          // { fieldName: 'MagentaTonerLeft', label: 'Magenta', isSortable: true, isHidden: false, isProgress: true },
          // { fieldName: 'YellowTonerLeft', label: 'Yellow', isSortable: true, isHidden: false, isProgress: true }
          { fieldName: 'ErrorString', label: 'Error', isSortable: true, isHidden: false, length: 20 }
        ]
      }
    },
    firebase: function () {
      let printerPath = 'Printers/' + this.$route.params.printerKey
      let printerRef = db.ref(printerPath)
      let deletedPrinterPath = 'DeletedPrinters/' + this.$route.params.printerKey
      let deletedPrinterRef = db.ref(deletedPrinterPath)
      return {
        printer: {
          source: printerRef,
          asObject: true,
          cancelCallback: function () { },
          readyCallback: function () {
            this.loadPrinterType()
            this.initPrinterInfo()
            this.loadPrinterHistory()
          }
        },
        deletedPrinter: {
          source: deletedPrinterRef,
          asObject: true,
          cancelCallback: function () { },
          readyCallback: function () {
            console.log('.value = ' + this.deletedPrinter['.value'])
            this.isDeleted = (this.deletedPrinter['.value'] !== null)
          }
        }
      }
    },
    created () {
      this.$root.title = 'Printer'
      this.loadingPrinter = true
    },
    mounted () {
      // this.$bus.$on('customerModal-open', (args) => {
      //  console.log(args)
      //  if (args) {
      //    this.title = 'Custumer Info'
      //    this.name = args.customerInfo.Name ? args.customerInfo.Name : ''
      //    this.email = args.customerInfo.Email ? args.customerInfo.Email : ''
      //    this.phone = args.customerInfo.Phone ? args.settings.Phone : ''
      //    this.address = args.customerInfo.Address ? args.settings.Address : ''
      //    this.city = args.customerInfo.City ? args.settings.City : ''
      //  } else {
      //    this.name = ''
      //  }
      //  $('#customerModal').modal('show')
      // })
    },
    computed: {
      isRefresh () {
        return this.printer && this.printer.IsRefresh === 'Refresh'
      }
    },
    watch: {
      deletedPrinter (val) {
        console.log(JSON.stringify(val))
      }
    },
    methods: {
      refreshPrinter () {
        let vm = this
        console.log('Refresh Printer ' + vm.printer.MacAddress)
        vm.printer.IsRefresh = 'Refresh'
        db.ref('Printers/' + vm.printer.MacAddress + '/IsRefresh').set('Refresh')
        dbListener.ref('RefreshPrinter/' + vm.printer.SiteKey + '/' + vm.printer.MacAddress).set(true)
        var starCountRef = db.ref('Printers/' + vm.printer.MacAddress)
        let listener = starCountRef.on('value', function (snapshot) {
          var printer = snapshot.val()
          console.log(printer)
          Object.keys(printer).map(key => {
            vm.printer[key] = printer[key]
          })
          if (printer.IsRefresh === 'Ready') {
            starCountRef.off('value', listener)
            vm.initPrinterInfo()
          }
        })
        vm.$root.refreshPrintersList.push({ MAC: vm.printer.MacAddress, Time: vm.$moment().format('YYYY-MM-DD HH:mm:ss') })
        if (vm.$root.timer === null) {
          vm.$root.timer = setInterval(vm.$root.resetRefreshPrinters, (1000 * 10 * 1))
        }
      },
      loadPrinterType () {
        console.log('loadPrinterType() started...')
        let vm = this
        let modelName = vm.getModelName()
        vm.printerType = {
          Key: '',
          ModelName: modelName,
          ImageUrl: '',
          IsMFC: false,
          IsPrinter: false,
          IsScanner: false,
          IsCopier: false,
          IsFax: false,
          IsColor: false,
          IsBW: false,
          IsA4: false,
          IsA3: false,
          IsDuplex: false
        }
        let printerTypeRef = db.ref('PrintersProfile')
        printerTypeRef.orderByChild('ModelName').equalTo(modelName).once('value', (snapPrinterType) => {
          const data = snapPrinterType.val()
          if (data) {
            console.log(data)
            // HERE >>>>>>>>>
            let key = Object.keys(data)[0]
            vm.printerType = data[key]
            vm.printerType.Key = key
            vm.printerProps = [
              { Key: 'Multi-Function', Value: vm.printerType.IsMFC },
              { Key: 'Printer', Value: vm.printerType.IsPrinter },
              { Key: 'Scanner', Value: vm.printerType.IsScanner },
              { Key: 'Copier', Value: vm.printerType.IsCopier },
              { Key: 'Fax', Value: vm.printerType.IsFax },
              { Key: 'Color', Value: vm.printerType.IsColor },
              { Key: 'Monochrome', Value: vm.printerType.IsBW },
              { Key: 'A4', Value: vm.printerType.IsA4 },
              { Key: 'A3', Value: vm.printerType.IsA3 },
              { Key: 'Duplex', Value: vm.printerType.IsDuplex }
            ]
          } else {
            vm.printerProps = [
              { Key: 'Multi-Function', Value: false },
              { Key: 'Printer', Value: false },
              { Key: 'Scanner', Value: false },
              { Key: 'Copier', Value: false },
              { Key: 'Fax', Value: false },
              { Key: 'Color', Value: false },
              { Key: 'Monochrome', Value: false },
              { Key: 'A4', Value: false },
              { Key: 'A3', Value: false },
              { Key: 'Duplex', Value: false }
            ]
          }
        })
      },
      getModelName () {
        console.log('getModelName() started...')
        let vm = this
        console.log('vm.printer.ModelName = ' + vm.printer.ModelName)
        let modelName = ''
        if (vm.printer.ModelName) {
          let modelNameArr = vm.printer.ModelName.split(' ')
          let indexOfNumeric = -1
          for (let s = 0; s < modelNameArr.length; s++) {
            let charsArr = modelNameArr[s].split('')
            for (let c = 0; c < charsArr.length; c++) {
              if (!isNaN(charsArr[c])) {
                indexOfNumeric = s
                break
              }
            }
            if (indexOfNumeric >= 0) {
              modelName += modelNameArr[s]
              break
            } else {
              modelName += modelNameArr[s] + ' '
            }
          }
          if (indexOfNumeric === -1) {
            modelName = vm.printer.ModelName
          }
        }
        return modelName
      },
      initPrinterInfo () {
        let vm = this
        this.title = 'Printer ' + '[' + this.printer.MacAddress + ']'
        this.title = 'Printer ' + '[' + this.printer['.key'] + ']'
        let cust = this.$root.customers.find(c => c.value === this.printer.CustomerKey)
        if (cust) {
          this.printer.Customer = cust.title
          vm.name = this.printer.Customer
        }
        let site = this.$root.sites.find(c => c.value === this.printer.SiteKey)
        if (site) {
          this.printer.Site = site.title
          vm.site = this.printer.Site
        }
        let dealer = this.$root.dealers.find(c => c.value === this.printer.DealerKey)
        if (dealer) {
          this.printer.dealer = dealer.title
          vm.dealer = this.printer.dealer
        }
        this.hostName = vm.printer.HostName
        this.CustomerKey = vm.printer.CustomerKey
        this.printer.PageCount = parseInt(this.printer.PageCount, 10)
        this.printer.A4Black = parseInt(this.printer.A4Black, 10)
        this.printer.A4Color = parseInt(this.printer.A4Color, 10)
        this.printer.A3Black = parseInt(this.printer.A3Black, 10)
        this.printer.A3Color = parseInt(this.printer.A3Color, 10)
        this.printer.BlackTonerLeft = this.parseTonerLeft(this.printer.BlackTonerLeft, 10)
        this.printer.CyanTonerLeft = this.parseTonerLeft(this.printer.CyanTonerLeft, 10)
        this.printer.MagentaTonerLeft = this.parseTonerLeft(this.printer.MagentaTonerLeft, 10)
        this.printer.YellowTonerLeft = this.parseTonerLeft(this.printer.YellowTonerLeft, 10)
        this.printerInfo = []
        this.printerCounters = []
        this.printerStatus = []
        this.printerToners = []
        this.lastUpdate = this.printer.Logged
        this.printerInfo.push({ title: 'Last Update', value: this.printer.Logged })
        this.printerInfo.push({ title: 'Serial Number', value: this.printer.PrinterSerial })
        this.printerInfo.push({ title: 'Model', value: this.printer.ModelName })
        this.printerInfo.push({ title: 'MAC Address', value: this.printer.MacAddress })
        this.printerInfo.push({ title: 'IP Address', value: this.printer.IPAddress })
        this.printerStatus.push({ title: 'Status', value: this.printer.Status })
        this.printerInfo.push({ title: 'Location', value: this.printer.Location })
        // this.printerStatus.push({ title: 'Error', value: this.printer.ErrorString })
        this.printerStatus.push({ title: 'Message', value: this.printer.ErrorString })
        this.printerToners.push({ title: 'Black', value: this.printer.BlackTonerLeft })
        this.printerToners.push({ title: 'Cyan', value: this.printer.CyanTonerLeft })
        this.printerToners.push({ title: 'Magenta', value: this.printer.MagentaTonerLeft })
        this.printerToners.push({ title: 'Yellow', value: this.printer.YellowTonerLeft })
        this.printerCounters.push({ title: 'Total Pages', value: this.printer.PageCount })
        this.printerCounters.push({ title: 'A4 Black', value: this.printer.A4Black })
        this.printerCounters.push({ title: 'A4 Color', value: this.printer.A4Color })
        this.printerCounters.push({ title: 'A3 Black', value: this.printer.A3Black })
        this.printerCounters.push({ title: 'A3 Color', value: this.printer.A3Color })
        this.printerCounters.push({ title: 'Copy', value: this.printer.Copy })
        this.printerCounters.push({ title: 'Scan', value: this.printer.Scan })
        this.printerCounters.push({ title: 'Duplex', value: this.printer.Duplex })
        this.printerCounters.push({ title: 'Fax', value: this.printer.Fax })
        this.searchImage('Printer ' + this.printer.ModelName)
        this.CustomerKey = this.printer.CustomerKey
        if (vm.Save) {
          let jsonObj = ''
          db.ref('PrintersForCustomerInfo/').orderByChild('MacAddress').equalTo(this.printer.MacAddress).once('value', (snapCustomer) => {
            console.log(this.CustomerKey)
            jsonObj = snapCustomer.val()
            console.log('test2' + jsonObj)
            let key = Object.keys(jsonObj)[0]
            vm.customerInfo = jsonObj[key]
            vm.customerInfo.Key = key
            vm.email = vm.customerInfo.Email
            vm.address = vm.customerInfo.Address
            vm.phone = vm.customerInfo.Phone
            vm.city = vm.customerInfo.City
            vm.contact = vm.customerInfo.Contact
            vm.customerInfo.MacAddress = vm.printer.MacAddress
          })
        }
        vm.loadingPrinter = false
      },
      loadPrinterHistory () {
        let vm = this
        vm.loadingPrinter = true
        // 00-00-74-81-8F-4C_201908160250
        // let fromDate = this.$moment().add(-30, 'days').format('YYYY-MM-DD')
        let fromDate = this.$moment().add(-6, 'months').format('YYYY-MM-DD')
        let toDate = this.$moment().format('YYYY-MM-DD')
        let fromDateInt = Number(this.$moment(fromDate).format('YYYYMMDD') + '0000')
        let toDateInt = Number(this.$moment(toDate).format('YYYYMMDD') + '0000')
        let MacAddress = this.printer['.key']
        let startAtValue = MacAddress + '_' + fromDateInt
        let endAtValue = MacAddress + '_' + toDateInt
        console.log('startAtValue = ' + startAtValue)
        console.log('endAtValue = ' + endAtValue)
        db.ref('History').orderByChild('MacAddress').equalTo(MacAddress).limitToLast(10).once('value', (snapPrintersHistory) => {
          vm.printerHistory = []
          const data = snapPrintersHistory.val()
          if (data) {
            const pritnerKeys = Object.keys(data)
            for (let i = 0; i < pritnerKeys.length; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              printer['.key'] = pKey
              printer.MacAddress = MacAddress
              vm.printerHistory.push(printer)
            }
            vm.printerHistory = vm.printerHistory.slice().sort(function (a, b) {
              return a.LoggedInt < b.LoggedInt ? -1 : 1
            })
          }
          vm.loadingPrinter = false
        })
      },
      imageChanged (index) {
        console.log('imageChanged started...')
        return
        /*
        let vm = this
        vm.loadingImage = true
        console.log(index)
        vm.printer.imgUrl = vm.images[index].PrinterImage
        vm.$forceUpdate()
        vm.checkImageURL(vm.printer.imgUrl).then((res) => {
          console.log(res)
          vm.loadingImage = false
          vm.$refs.printerImage.onload = function () {
            vm.loadingImage = false
          }
        }).catch((err) => {
          console.log(err)
          vm.printer.imgUrl = 'https://www.tenforums.com/geek/gars/images/2/types/thumb_Printer.png'
          vm.loadingImage = false
        })
        */
      },
      checkImageURL (url) {
        // return (url.match(/\.(jpeg|jpg|gif|png)$/) != null)
        return new Promise(function (resolve, reject) {
          let timeout = 5000
          let timer
          let img = new Image()
          img.onerror = img.onabort = function () {
            clearTimeout(timer)
            reject('error')
          }
          img.onload = function () {
            clearTimeout(timer)
            resolve('success')
          }
          timer = setTimeout(function () {
            // reset .src to invalid URL so it stops previous
            // loading, but doesn't trigger new load
            img.src = '//!!!!/test.jpg'
            reject('timeout')
          }, timeout)
          img.src = url
        })
      },
      searchImage (searchText) {
        let vm = this
        console.log('searchImage() started...')
        let apiKey = 'AIzaSyBKXcaAZrsz91TC3i9S0dvSrhJQOylvuiM'
        let searchUrl = 'https://www.googleapis.com/customsearch/v1?'
        let imagesCount = 6
        let imgSize = 'medium'
        let searchParam = '&cx=008839605979897967218%3A2zdeuwpod6k&fileType=png&imgColorType=color&imgType=photo&lr=lang_en&searchType=image&prettyPrint=true'
        searchUrl += 'q=' + searchText
        searchUrl += '&key=' + apiKey
        searchUrl += '&num=' + imagesCount
        searchUrl += '&imgSize=' + imgSize
        searchUrl += searchParam

        console.log('searchUrl = ' + searchUrl)
        // axios
        axios.get(searchUrl)
          .then(function (response) {
            console.log('axios.then()...')
            vm.images = []
            vm.images.push({
              PrinterImage: 'https://www.tenforums.com/geek/gars/images/2/types/thumb_Printer.png',
              Thumbnail: 'https://www.tenforums.com/geek/gars/images/2/types/thumb_Printer.png'
            })
            let searchResult = response.data.items
            if (searchResult && searchResult && searchResult.length > 0) {
              for (let i = 0; i < searchResult.length; i++) {
                vm.images.push({ PrinterImage: searchResult[i].link, Thumbnail: searchResult[i].image.thumbnailLink })
              }
            }
            console.log(vm.images)
            // vm.printer.imgUrl = vm.images[0].PrinterImage
            vm.imageChanged(0)
            // vm.$forceUpdate()
          })
          .catch(function (error) {
            // handle error
            console.log('axios.catch()...')
            console.log(error)
          })
          .finally(function () {
            console.log('axios.finally()...')
            // always executed
          })
      },
      parseTonerLeft (colorLeft) {
        // let colorLeftPercent = ''
        let colorLeftInt = 0
        if (colorLeft && colorLeft.length > 0) {
          if (colorLeft.indexOf('-') >= 0) {
            colorLeftInt = 0
          }
          colorLeft = colorLeft.replace('%', '')
          colorLeft = colorLeft.split('.')[0]
          colorLeftInt = parseInt(colorLeft, 10)
        } else {
          // colorLeftInt = -1
          colorLeftInt = ''
        }
        if (colorLeftInt > 100) { colorLeftInt = 100 }
        if (colorLeftInt < 0) { colorLeftInt = 0 }
        if (isNaN(colorLeftInt)) {
          colorLeftInt = 0
        }
        return colorLeftInt
        // colorLeftPercent = colorLeftInt + '%'
        // return colorLeftPercent
      },
      Save () {
        let vm = this
        console.log(vm.CustomerKey)
        vm.customerInfo.Phone = vm.phone
        vm.customerInfo.City = vm.city
        vm.customerInfo.Email = vm.email
        vm.customerInfo.Address = vm.address
        vm.customerInfo.City = vm.city
        vm.customerInfo.Contact = vm.contact
        vm.customerInfo.Name = vm.name
        vm.customerInfo.customerKey = vm.CustomerKey
        vm.customerInfo.site = vm.site
        vm.customerInfo.dealer = vm.dealer
        vm.customerInfo.hostName = vm.hostName
        vm.customerInfo.MacAddress = vm.printer.MacAddress
        db.ref('PrintersForCustomerInfo/' + vm.printer.MacAddress).set(vm.customerInfo).then(function (result) {
          console.log(vm.customerInfo)
          console.log('CustomerSettings Saved!')
        }).catch(function (err) {
          console.log('CustomerSettings Failed !!!')
          console.log(err)
        })
        for (let i = 0; i < vm.printerProps.length; i++) {
          switch (vm.printerProps[i].Key) {
            case 'Multi-Function': vm.printerType.IsMFC = vm.printerProps[i].Value; break
            case 'Printer': vm.printerType.IsPrinter = vm.printerProps[i].Value; break
            case 'Scanner': vm.printerType.IsScanner = vm.printerProps[i].Value; break
            case 'Copier': vm.printerType.IsCopier = vm.printerProps[i].Value; break
            case 'Fax': vm.printerType.IsFax = vm.printerProps[i].Value; break
            case 'Color': vm.printerType.IsColor = vm.printerProps[i].Value; break
            case 'Monochrome': vm.printerType.IsBW = vm.printerProps[i].Value; break
            case 'A4': vm.printerType.IsA4 = vm.printerProps[i].Value; break
            case 'A3': vm.printerType.IsA3 = vm.printerProps[i].Value; break
            case 'Duplex': vm.printerType.IsDuplex = vm.printerProps[i].Value; break
          }
        }
        if (vm.printerType.key && vm.printerType.key.length > 0) {
          db.ref('PrintersProfile/' + vm.printerType.key).set(vm.printerType)
        } else {
          delete vm.printerType.key
          db.ref('PrintersProfile').push(vm.printerType)
        }
        vm.$root.showAlert('Printer Properties', 'Printer Info was save successfuly.')
        vm.$root.reloadSlideItems()
      },
      cancelType () {
        this.loadPrinterType()
      },
      restorePrinter () {
        let vm = this
        console.log(JSON.stringify(vm.deletedPrinter))
        let deletedPrinterPath = 'DeletedPrinters/' + vm.$route.params.printerKey
        let copyDeletedPritner = {
          MacAddress: vm.deletedPrinter.MacAddress,
          IPAddress: vm.deletedPrinter.IPAddress,
          PrinterName: vm.deletedPrinter.PrinterName,
          ModelName: vm.deletedPrinter.ModelName,
          PrinterSerial: vm.deletedPrinter.PrinterSerial,
          UID: vm.deletedPrinter.UID,
          SiteKey: vm.deletedPrinter.SiteKey,
          CustomerKey: vm.deletedPrinter.CustomerKey,
          DealerKey: vm.deletedPrinter.DealerKey
        }
        console.log(copyDeletedPritner)
        db.ref(deletedPrinterPath).remove().then(function (data) {
          console.log(JSON.stringify(vm.deletedPrinter))
          vm.updateClientRestorePrinter(copyDeletedPritner)
          vm.refreshPrinter()
        })
      },
      updateClientRestorePrinter (item) {
        console.log('updateClientRestorePrinter(' + item.MacAddress + ')')
        dbListener.ref('UpdateClient/' + item.SiteKey + '/RestorePrinters').once('value').then(function (snapData) {
          let strData = snapData.val()
          console.log('strData: ' + strData)
          if (strData) {
            strData = strData.toLowerCase()
            let arr = strData.split(',')
            if (arr && arr.length > 0) {
              let index = arr.indexOf(item.MacAddress.toLowerCase())
              if (index === -1) {
                arr.push(item.MacAddress)
                strData = arr.join(',')
                dbListener.ref('UpdateClient/' + item.SiteKey + '/RestorePrinters').set(strData).then(function () {
                  console.log('RestorePrinters [' + item.MacAddress + '] Was set to [Done].')
                  location.reload(true)
                }).catch(function (error) {
                  console.log('Error: ' + error.message)
                })
              }
            }
          } else {
            dbListener.ref('UpdateClient/' + item.SiteKey + '/RestorePrinters').set(item.MacAddress)
          }
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Printer.vue?bad085d6